import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['saveForLater']

  // Bound to click on submit buttons (data-action="custom-field-form#submit").
  //
  // Survey "Save for later" is a second submit button (`name=save_for_later`).
  // Production's Altcha floating widget (auto=onsubmit) intercepts the native
  // submit event and re-fires `form.requestSubmit()` with no submitter — which
  // drops the clicked button's name/value and ignores its formnovalidate.
  // The template owns the hidden input (saveForLater target); we only stamp
  // it here on click, before Altcha runs. Forms without that target
  // (builder, etc.) are unchanged.
  submit(event) {
    const savingForLater = event?.currentTarget?.name === 'save_for_later'
    if (this.hasSaveForLaterTarget) {
      this.saveForLaterTarget.value = savingForLater ? '1' : ''
      this.element.noValidate = savingForLater
      if (savingForLater) return
    }

    if (this.element.checkValidity()) return

    // Find the first invalid form field and expand its section
    // to focus it.
    const invalid = this.element.querySelectorAll(':invalid')[0]
    const section = invalid.closest('.section-outlet')
    const sectionController =
      this.application.getControllerForElementAndIdentifier(
        section,
        'custom-field--section'
      )

    if (sectionController) sectionController.expand()
  }
}
